import React, { useEffect, useState } from "react";
import { getBrandswapHostedDetails } from "../services/offers/offers.service";
import { useParams } from "react-router-dom";

function Home() {
  const [token, setToken] = useState("");
  const { id } = useParams();

  useEffect(() => {
    document.title = "BrandSwap Hosted";
  }, []);

  useEffect(() => {
    const fetchReward = async (id: string) => {
      const response = await getBrandswapHostedDetails(id);
      response &&
        response.status &&
        response?.data?.result?.companyToken &&
        setToken(response?.data.result.companyToken);
    };
    id && fetchReward(id);
  }, [id]);

  useEffect(() => {
    if (token) {
      const script = document.createElement("script");

      script.src = `${process.env.REACT_APP_ADMIN_SCRIPT_URL}`;

      script.async = true;
      script.setAttribute("id", "brandswopinitscript");
      script.setAttribute("token", token);
      script.setAttribute("loadui", "true");

      document.body.appendChild(script);
      setTimeout(() => {
        window.top?.postMessage({ event: "setPageTitle", load: "" }, "*");
      }, 1000);
    }
  }, [token]);

  return <div id="brandswap-hosted" className="brandswap-hosted"></div>;
}

export default Home;
